import React from "react";
import { Button, Col, Row, Slider, Tabs, Upload, Select ,Switch} from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as EditIcon } from "@/assets/icons/edit.svg";
import { ReactComponent as EraseIcon } from "@/assets/icons/erase.svg";
import { PlusOutlined } from "@ant-design/icons";
import InputColor from "react-input-color";
const { TabPane } = Tabs;
const { Option } = Select;

const ImageCutoutEditWorkBarRender = ({
  uploadProps,
  bgImageRefList,
  brushType,
  brushSize,
  colorList,
  isShowShadows,
  shadowColor,
  shadowsColorList,
  isShadowsMove,
  bgList,
  backgroundImgaeFitType,
  handleBrushType,
  handleBrushSize,
  handleBackground,
  handleBackgroundImage,
  handleBackgroundImageFit,
  handleSetBackgroundByColorInput,
  handleDownload,
  handleSetShadowColorByColorInput,
  handleShadowColor,
  shadowsChange,
  handleIntensitySize,
  intensitySize,
  handleRadiusSize,
  radiusSize,
  selectShadowsMove,
  handleShadowChange
}) => {
  const { t } = useTranslation(["imageCutout", "common"]);

  return (
    <div className="work-cont-edit-workBar">
      <div style={{ flex: "auto" }}>
        <p className="edit-title">{t("Adjust Picture")}</p>
        <Row gutter={[16, 18]} className="main-edit">
          <Col span={12}>
            <Button
              className={brushType !== "restore" ? "gray" : ""}
              type="primary"
              ghost
              icon={<EditIcon />}
              onClick={() => handleBrushType("restore")}
            >
              {t("Restore")}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              className={brushType !== "erase" ? "gray" : ""}
              type="primary"
              ghost
              icon={<EraseIcon />}
              onClick={() => handleBrushType("erase")}
            >
              {t("Eraser")}
            </Button>
          </Col>
          <Col span={24}>
            <span className="edit-label">{t("Size")}</span>
            <Slider min={1} max={100} value={brushSize} onChange={handleBrushSize} />
          </Col>
        </Row>

        <div style={{borderBottom: "1px solid #454649",padding:"0 0 0px 0"}}>
          <Row gutter = {[16, 28]} justify = "space-between" align = "middle" style={{ padding: "0 24px 0px 16px",borderBottom:"0px" }} className = "main-edit" >
            <Col span={10} style={{lineHeight:"10px"}}>
              <span className="edit-label">{t("Shadows")}</span>
            </Col>
            <Switch size="small" defaultChecked={false} onChange={shadowsChange} />
          </Row>
          <div > {isShowShadows ? (<div>
          <div style = {{margin: "0 24px",padding:"10px 16px",borderRadius:"4px", background: "#2E2F30"}}>
            <Tabs defaultActiveKey="1" onChange={handleShadowChange}>

              <TabPane tab={t("Intensity")} key="1">
                <div style={{display:"flex",position:"relative"}}>
                  <Col span={17}>
                    <span className="edit-label">{t("Intensity")}</span>
                    <Slider min={1} max={100} value={ intensitySize} onChange={handleIntensitySize} />
                  </Col>
                  <span className="slider-num">{intensitySize}</span>
                </div>
              </TabPane>
              <TabPane tab={t("Radius")} key="2">
                 <div style={{display:"flex",position:"relative"}}>
                  <Col span={17}>
                    <span className="edit-label">{t("Radius")}</span>
                    <Slider min={1} max={100} value={ radiusSize} onChange={handleRadiusSize} />
                  </Col>
                  <span className="slider-num">{radiusSize}</span>
                </div>
              </TabPane>
              <TabPane tab={t("Color")} key="3">
                <Col span={24}>
                  <span className="edit-label">{t("Color")}</span>
                  <Row className="color-list" wrap={true} gutter={[11, 0]}>
                        {
                          shadowsColorList.map(item => (
                          <Col key={item}>
                            {item === "selector" ? (
                              <div className = "color-btn text-color-btn">
                                  <InputColor initialValue={shadowColor} onChange={handleSetShadowColorByColorInput} placement="top" />
                                  <span className="color-value">{shadowColor}</span>
                              </div>
                            ) : (
                              <div
                                className={`color-btn ${item === "transparent" ? item : ""}`}
                                style={{ background: item }}
                                onClick={() => handleShadowColor(item)}
                              ></div>
                            )}
                          </Col>
                        ))}
                  </Row>
                </Col>
              </TabPane>
            </Tabs>
          </div>
          <div  className = {
            isShadowsMove ? 'shadowsMove' : 'unShadowsMove'
          }
          onClick = {
            selectShadowsMove
          }
          style = {
            {
              margin: '16px 24px'
            }
          } >
              <div className="shadowsMoveImg"></div>
              <div className="shadowsMoveText">{t("Move")}</div>
          </div>
          <div className="shadowsText" style={{margin:"0px 24px 24px 24px"}}>{t("Move the shadow")}</div>
        </div>):""}
          </div>
        </div>

        <div style={{ padding: "24px 24px 0 24px" }}>
          <p className="edit-title" style={{ padding: 0 }}>
            {t("Background")}
          </p>
          <Tabs defaultActiveKey="1">
             <TabPane tab={t("Presets")} key="1">
              <Row className="color-list" wrap={true} gutter={[11, 0]}>
                {colorList.map(item => (
                  <Col key={item}>
                    {item === "selector" ? (
                      <div className="color-btn">
                        <InputColor initialValue="#000" onChange={handleSetBackgroundByColorInput} placement="top" />
                      </div>
                    ) : (
                      <div
                        className={`color-btn ${item === "transparent" ? item : ""}`}
                        style={{ background: item }}
                        onClick={() => handleBackground(item)}
                      ></div>
                    )}
                  </Col>
                ))}
              </Row>
              <Row className="bg-list" gutter={[16, 16]}>
                {bgList.map((item, index) => (
                  <Col key={index} span={8} onClick={() => handleBackgroundImage(index)}>
                    <div className="bg-btn">
                      <img src={item} alt="bg" ref={ref => (bgImageRefList[index] = ref)} />
                    </div>
                  </Col>
                ))}
              </Row>
            </TabPane>
            <TabPane tab={t("Custom")} key="2">
              <Upload {...uploadProps}>
                <Button className="gray" icon={<PlusOutlined />}>
                  {t("Add Image")}
                </Button>
              </Upload>
              <p className="edit-label">{t("Scale to Fit")}</p>
              <Select
                defaultValue="custom"
                className="dark-select"
                dropdownClassName="dark-select-dropdown-new"
                onChange={handleBackgroundImageFit}
                value={backgroundImgaeFitType}
              >
                <Option value="custom">{t("Custom")}</Option>
                <Option value="width">{t("Full Width")}</Option>
                <Option value="height">{t("Full Height")}</Option>
              </Select>
            </TabPane>
   
          </Tabs>
        </div>
      </div>
      <Button className="download-btn" type="primary" onClick={handleDownload}>
        {t("common:Download")}
      </Button>
    </div>
  );
};

export default ImageCutoutEditWorkBarRender;
